import React from 'react';

const Header = () => {
  return (
    <header className="bg-white/80 backdrop-blur-md shadow-sm fixed top-0 left-0 right-0 z-50 border-b border-gray-100">
      <div className="container-max">
        <div className="flex justify-between items-center py-4 px-6 sm:px-8 lg:px-12">
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center mr-3 shadow-lg">
              <span className="text-white font-bold text-lg">T</span>
            </div>
            <span className="text-2xl font-bold text-gray-900">Tareia</span>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#como-funciona" className="text-gray-600 hover:text-primary-600 transition-colors font-medium">
              Cómo funciona
            </a>
            <a href="#beneficios" className="text-gray-600 hover:text-primary-600 transition-colors font-medium">
              Beneficios
            </a>
          </nav>
          
          <button 
            className="btn-primary text-xs sm:text-sm py-2 px-3 sm:py-4 sm:px-8"
            onClick={() => {
              const cta = document.getElementById('cta');
              if (cta) {
                const headerHeight = 72;
                const top = cta.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                window.scrollTo({ top, behavior: 'smooth' });
              }
            }}
          >
            🚀 Quiero acceso anticipado
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;